export default ['JsonRPCService', (JsonRPCService) => {
    return {
        getRefundMethods: (policyNumber, tempCancellation) => {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'getValidRefundMethods', [policyNumber, tempCancellation]);
        },
        getEffectiveDateForCancellation: (policyNumber, tempCancellation) => {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'getEffectiveDateForCancellation', [policyNumber, tempCancellation]);
        },
        findJobByJobNumber: (cancellationNumber) => {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'findJobByJobNumber', [cancellationNumber]);
        },
        getCancellationSummary: (cancellationNumber) => {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'getCancellationSummary', [cancellationNumber]);
        },
        getNotesForCancellation: (cancellationNumber) => {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'getNotesForCancellation', [cancellationNumber]);
        },
        createNoteForCancellation: (cancellationNumber, noteDTO) => {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'createNoteForCancellation', [cancellationNumber, noteDTO]);
        },
        getDocumentsForCancellation: (cancellationNumber) => {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'getDocumentsForCancellation', [cancellationNumber]);
        },
        getUWIssuesForCancellation: (cancellationNumber) => {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'getUWIssuesForCancellation', [cancellationNumber]);
        },
        referToUnderwriter: (cancellationNumber, noteBody) => {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'referToUnderwriter', [cancellationNumber, noteBody]);
        },
        withdrawCancellationByCancellationNumber: (cancellationNumber) => {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'withdrawCancellationByJobNumber', [cancellationNumber]);
        },
        bindCancellation: (cancellationNumber) => {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'bindCancellation', [cancellationNumber]);
        }
    };
}];